import { useAuthService } from '@invivodf/front-seller-auth'
import { buildCallerId } from '@invivodf/front-seller-caller-id'
import sdk, { LogisticOfferSDK, LogisticOfferForConfig, LogisticOffer } from '@invivodf/module-logistic-offer-sdk'
import { LogisticSettings } from '../domain'

class LogisticRepository {
  private logisticOfferSDK: LogisticOfferSDK

  constructor({ logisticApiHost }) {
    this.logisticOfferSDK = sdk(logisticApiHost, {
      callerId: buildCallerId(),
      accessTokenSource: () => useAuthService().getAccessToken(),
    })
  }

  save(sellerId: string, logisticOffer: LogisticOffer): Promise<LogisticOffer> {
    return this.logisticOfferSDK.saveLogisticOffer(sellerId, logisticOffer)
  }

  getAll(sellerId: string): Promise<LogisticOffer[]> {
    return this.logisticOfferSDK.getLogisticOffersWithoutAssociation(sellerId)
  }

  getAllWithAssociations(sellerId: string): Promise<LogisticOfferForConfig[]> {
    return this.logisticOfferSDK.getLogisticOffersWithAssociations(sellerId)
  }

  get(sellerId: string, reference: string): Promise<LogisticOfferForConfig> {
    return this.logisticOfferSDK.getLogisticOffer(sellerId, reference)
  }

  delete(sellerId: string, reference: string): Promise<void> {
    return this.logisticOfferSDK.deleteLogisticOffer(sellerId, reference)
  }

  async getSettings(sellerId: string): Promise<LogisticSettings> {
    const setting = await this.logisticOfferSDK.getLogisticSettings(sellerId)
    return { isShippingFree: setting.isShippingFree }
  }

  async setSettings(sellerId: string, settings: LogisticSettings): Promise<void> {
    return this.logisticOfferSDK.saveLogisticSettings({
      partnerId: sellerId,
      isShippingFree: settings.isShippingFree,
    })
  }
}

export default LogisticRepository
